import { pushToStack, useOneStackItem } from './combinators';
import { OpcodesCommon } from './opcodes';
import { bigIntToScriptNumber } from './types';
export const opSize = () => (state) => useOneStackItem(state, (nextState, [item]) => pushToStack(nextState, item, bigIntToScriptNumber(BigInt(item.length))));
export const spliceOperations = () => ({
    [OpcodesCommon.OP_SIZE]: opSize(),
});
//# sourceMappingURL=splice.js.map